import { useEffect, useState } from "react";
import { http } from "@/lib/api";

export function usePrices() {
  const [prices, setPrices] = useState({ rate: null, options: [], ritual: null });
  useEffect(() => {
    http.get("/services")
      .then((r) => {
        const list = Array.isArray(r.data) ? r.data : [];
        const reading = list.find((s) => s?.id === "psychic-reading");
        const ritual = list.find((s) => s?.id === "moon-ritual");
        setPrices({ rate: reading?.rate_per_minute ?? null, options: Array.isArray(reading?.options) ? reading.options : [], ritual: ritual?.price ?? null });
      })
      .catch(() => {});
  }, []);
  return prices;
}

export const money = (n) => `$${Number(n).toFixed(2).replace(/\.00$/, "")}`;
